<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja"class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <span>Condições Comerciais</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">Condições Comerciais</h3>
          </div>
        </div>
        <div class="row static-text">
          <div class="col-xs-12">
              <div class="alert alert-info" role="alert">
                <p>Faturamento mínimo de R$ 250,00. Acima de R$ 250,00 Prazo: 21DD. Acima de R$ 700,00 Prazo: 21DD ou 21/28D. Acima de R$ 1.050,01 Prazo: 28DD ou 21/28/35D ou 14/21/35/42D ou 14/21/28/35/42D. Acima de R$ 10.000,00 Prazo: 35DD ou 28/42D ou 28/35/42D ou 21/35/49D ou 21/28/35/42/49D. *Parcela mínima de R$ 350,00.</p>
              </div>
          </div>
        </div>
        <div class="row static-text">
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <div class="aboutus-info style-small-left">
              <b class="box-title">BENEFÍCIOS E CONDIÇÕES COMERCIAIS ESPECIAIS</b>
              <p class="txt-content">Exclusivos para Aldo Crazy Card (consulte a sua categoria);</p>
            </div>
            <div class="aboutus-info style-small-left">
              <b class="box-title">FRETE CIF</b>
              <p
                class="txt-content"
              >Consulte as opções de transportadora e a taxa de logística para sua região;</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <div class="aboutus-info style-small-left">
              <b class="box-title">TODOS OS IMPOSTOS INCLUSOS</b>
              <p
                class="txt-content"
              >Exceto para produtos que, em alguns estados, são acrescidos do ICMS de substituição tributária (consulte);</p>
            </div>
            <div class="aboutus-info style-small-left">
              <b class="box-title">PEDIDOS</b>
              <p class="txt-content">Sujeitos à aprovação de crédito e confirmação de estoque;</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <div class="aboutus-info style-small-left">
              <b class="box-title">PREÇOS E CONDIÇÕES</b>
              <p class="txt-content">Sujeitos a alteração sem aviso prévio;</p>
            </div>
            <div class="aboutus-info style-small-left">
              <b
                class="box-title"
              >TODOS OS PRODUTOS E SERVIÇOS SÃO FATURADOS E DESPACHADOS A PARTIR DE:</b>
              <p class="txt-content">MARINGÁ-PR, AV. ADVOGADO HORÁCIO RACCANELLO FILHO, 1836.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">Parcelamentos</h3>
          </div>
        </div>        
        <div class="row static-text">
          <div class="col-md-12">
            <table class="table table-bordered">
              <thead>
                  <tr>
                      <th>De R$ </th>
                      <th>Até R$ </th>
                      <th>Parcela Mínima R$ </th>
                      <th>Parcelamento</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>250,00</td>
                      <td>699,99</td>
                      <td>250,00</td>
                      <td>21</td>
                  </tr>
                  <tr>
                      <td rowspan="3">700,00</td>
                      <td rowspan="3">1.050,00</td>
                      <td rowspan="3">350,00</td>
                      <td>21</td>
                  </tr>
                  <tr>
                      <td>21 / 28</td>
                  </tr>
                  <tr>
                      <td>14 / 21 / 28</td>
                  </tr>
                  <tr>
                      <td rowspan="6">1.050,01</td>
                      <td rowspan="6">9.999,99</td>
                      <td rowspan="6">350,00</td>
                      <td>28</td>
                  </tr>
                  <tr>
                      <td>21 / 35</td>
                  </tr>
                  <tr>
                      <td>21 / 28 / 35</td>
                  </tr>
                  <tr>
                      <td>14 / 28 / 42</td>
                  </tr>
                  <tr>
                      <td>14 / 21 / 35 / 42</td>
                  </tr>
                  <tr>
                      <td>14 / 21 / 28 / 35 / 42</td>
                  </tr>
                  <tr>
                      <td rowspan="7">10.000,00</td>
                      <td rowspan="7">-</td>
                      <td rowspan="7">2.000,00</td>
                      <td>35</td>
                  </tr>
                  <tr>
                      <td>21 / 49</td>
                  </tr>
                  <tr>
                      <td>28 / 42</td>
                  </tr>
                  <tr>
                      <td>21 / 35 / 49</td>
                  </tr>
                  <tr>
                      <td>28 / 35 / 42</td>
                  </tr>
                  <tr>
                      <td>21 / 28 / 42 / 49</td>
                  </tr>
                  <tr>
                      <td>21 / 28 / 35 / 42 / 49</td>
                  </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "CommercialConditions"
};
</script>
    